import { Container, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { formatPrice } from '../../utils/utils';

export type customBarchartProps = {
  label: string;
  total: number;
  data: any[];
  showLegend: boolean;
};

const BarChart = ({ label, total, data, showLegend }: customBarchartProps) => {
  return (
    <Container className="custom-barchart p-0">
      <section>
        <div className="d-flex flex-row barchart-label justify-content-between">
          <span className="fw-light text-caption lh-xxs">{label}</span>
          <span className="fw-normal text-caption lh-xxs">
            {formatPrice(total)}
          </span>
        </div>
        <div className={'barchart mt-3 d-flex'}>
          {data.map((chart, i) => (
            <OverlayTrigger
              placement="top"
              key={i}
              overlay={
                <Tooltip id={`tooltip-top`}>
                  {chart.tooltipPrice
                    ? formatPrice(chart.tooltipPrice)
                    : chart.value}
                </Tooltip>
              }
            >
              <div
                className="d-inline-block charts"
                style={{
                  width: `${chart.value}%`,
                  backgroundColor: `${chart.color}`,
                  height: '100%',
                }}
              ></div>
            </OverlayTrigger>
          ))}
        </div>
      </section>
      {showLegend && (
        <section>
          {data.map((chart, i) => (
            <div className="d-flex flex-row align-items-center pt-7" key={i}>
              <span
                className="d-flex justify-content-center align-items-center legend-indicator"
                style={{ backgroundColor: chart.color }}
              />
              <span className="text-caption fw-light ps-3 lh-xxs text-light-grey-normal">
                {chart.label}
              </span>
            </div>
          ))}
        </section>
      )}
    </Container>
  );
};

export default BarChart;
